<template>
  <DropdownField
    id="institution-list"
    name="transactSSO.institutionId"
    optionLabel="name"
    optionValue="id"
    :options="institutions"
    :placeholder="
      t('sites.singleSite.financialConfig.mealPlans.form.transactSSOInstitutionPlaceholder')
    "
    :required="true"
    :disabled="!editMealPlan"
  />
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useMealPlanStore } from '../../../../../../../routes/stores/use-meal-plan-store';
import { useFinancialConfigStore } from '../../../../../../../routes';
import type { Institution } from '@compassdigital/sdk.typescript/interface/mealplan';

const { t } = useI18n();
const financialConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(financialConfigStore);
const mealPlanStore = useMealPlanStore();
const { institutionList } = storeToRefs(mealPlanStore);

// Transform the institution list to ensure it has 'id' and 'name' fields
const institutions = computed(() => {
  return institutionList.value.map((institution: Institution) => ({
    id: institution.InstitutionId,
    name: institution.Name,
  }));
});
</script>
